import React, { useMemo } from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { trpc } from "@editor/utils/trpc";

import FunnelCanvas from "@/features/funnel/components/FunnelCanvas";
import FunnelPagesMenu from "@/features/funnel/components/FunnelPagesMenu";

function FunnelEditor({ funnelId }: { funnelId: string }) {
  const projectId = useCurrentProjectId();
  const { data: funnel, refetch: refetchFunnel } = trpc.funnel.find.useQuery(
    {
      projectId: projectId ?? "",
      funnelId,
    },
    {
      enabled: Boolean(projectId && funnelId),
    },
  );

  const { mutate: updateFunnelStepOrder } =
    trpc.funnel.updateFunnelStepOrder.useMutation({
      onSuccess: () => {
        void refetchFunnel();
      },
    });

  const funnelPages = useMemo(() => {
    return funnel?.funnelSteps
      ?.map((step, index) => ({
        pageRoute: step.file?.pageRoute ?? "",
        index,
        name: step.file?.name ?? undefined,
        id: step.file?.id,
        funnelStepId: step.id,
      }))
      .filter((page) => page.pageRoute !== "");
  }, [funnel]);

  if (!funnelPages) {
    return null;
  }

  return (
    <div className="flex h-full w-full items-center justify-center rounded-lg bg-white gap-3">
      <div className="border-t-0.5 border-border h-full pt-3 flex flex-col gap-3">
        <h4 className="text-default text-base font-semibold">Pages</h4>
        <FunnelPagesMenu
          funnelId={funnelId}
          updateFunnelStepOrder={updateFunnelStepOrder}
        />
      </div>

      <FunnelCanvas funnelPages={funnelPages} projectId={projectId} />
    </div>
  );
}

export default FunnelEditor;
